var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "report_breakdown",
    "data-name": "report breakdown",
    transform: "translate(122 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(396 346)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(131.831 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.919,
    cy: 0.919,
    r: 0.919,
    transform: "translate(279.19 348.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16024",
    "data-name": "Group 16024",
    transform: "translate(266.513 332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    d: "M2.758,1.379A1.381,1.381,0,0,0,1.379,2.758v15.63a1.381,1.381,0,0,0,1.379,1.379H15.63a1.381,1.381,0,0,0,1.379-1.379V2.758A1.381,1.381,0,0,0,15.63,1.379H2.758M2.758,0H15.63a2.758,2.758,0,0,1,2.758,2.758v15.63a2.758,2.758,0,0,1-2.758,2.758H2.758A2.758,2.758,0,0,1,0,18.389V2.758A2.758,2.758,0,0,1,2.758,0Z",
    transform: "translate(0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    d: "M1.379,1.379v9.194H17.01V1.379H1.379M0,0H18.389V11.953H0Z",
    transform: "translate(0 3.678)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M.629,9.2H-.75V0H.629Z",
    transform: "translate(9.209 5.054)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M5.456.629H-.06A.69.69,0,0,1-.75-.06.69.69,0,0,1-.06-.75H5.456a.69.69,0,0,1,.69.69A.69.69,0,0,1,5.456.629Z",
    transform: "translate(6.496 17.53)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16023",
    "data-name": "Group 16023",
    transform: "translate(2.069 20.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_40",
    "data-name": "Line 40",
    d: "M.629,2.758H-.75V0H.629Z",
    transform: "translate(0.75 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_41",
    "data-name": "Line 41",
    d: "M.629,2.758H-.75V0H.629Z",
    transform: "translate(9.944 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_42",
    "data-name": "Line 42",
    d: "M.629,2.758H-.75V0H.629Z",
    transform: "translate(4.428 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_43",
    "data-name": "Line 43",
    d: "M.629,2.758H-.75V0H.629Z",
    transform: "translate(13.622 0)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23_-_Outline",
    "data-name": "Ellipse 23 - Outline",
    d: "M.919,0A.919.919,0,1,1,0,.919.919.919,0,0,1,.919,0Z",
    transform: "translate(3.218 16.55)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_24_-_Outline",
    "data-name": "Ellipse 24 - Outline",
    d: "M.919,0A.919.919,0,1,1,0,.919.919.919,0,0,1,.919,0Z",
    transform: "translate(13.332 16.55)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_44",
    "data-name": "Line 44",
    d: "M30.281.629H-.06A.69.69,0,0,1-.75-.06.69.69,0,0,1-.06-.75H30.281a.69.69,0,0,1,.69.69A.69.69,0,0,1,30.281.629Z",
    transform: "translate(265.919 355.046)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16032",
    "data-name": "Group 16032",
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 290.543, 338.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16031",
    "data-name": "Group 16031",
    transform: "translate(-0.335 -0.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27744",
    "data-name": "Path 27744",
    d: "M21.088,179.963a.464.464,0,0,1-.111-.013,2.321,2.321,0,1,1,2.678-3.181.466.466,0,0,1-.854.372,1.389,1.389,0,1,0-1.6,1.9.466.466,0,0,1-.11.919Z",
    transform: "translate(-19.205 -173.355)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27745",
    "data-name": "Path 27745",
    d: "M283.48,23.126a.466.466,0,0,1-.451-.349,2.854,2.854,0,1,1,5.523-1.439.466.466,0,0,1-.9.235,1.922,1.922,0,1,0-3.719.969.466.466,0,0,1-.451.584Z",
    transform: "translate(-279.526 -19.204)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27746",
    "data-name": "Path 27746",
    d: "M98.718,434.667a2.321,2.321,0,0,1-1.254-4.276.466.466,0,1,1,.5.785,1.389,1.389,0,0,0,1.5,2.341.466.466,0,1,1,.5.785A2.308,2.308,0,0,1,98.718,434.667Z",
    transform: "translate(-95.394 -425.002)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27747",
    "data-name": "Path 27747",
    d: "M764.44,353.5a1.963,1.963,0,0,1-.336-.029.466.466,0,1,1,.16-.918,1.027,1.027,0,1,0,.352-2.024.466.466,0,0,1,.16-.918,1.959,1.959,0,0,1-.335,3.889Z",
    transform: "translate(-754.09 -345.335)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M622.666,128.426a.466.466,0,0,1-.258-.854,1.121,1.121,0,1,0-1.689-1.268.466.466,0,0,1-.889-.278,2.053,2.053,0,1,1,3.093,2.323A.464.464,0,0,1,622.666,128.426Z",
    transform: "translate(-612.041 -123.222)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M693.151,598.425a1.941,1.941,0,0,1-.593-.093.466.466,0,1,1,.284-.887,1.029,1.029,0,0,0,1.336-1.072.466.466,0,1,1,.928-.084,1.961,1.961,0,0,1-1.774,2.128Q693.241,598.425,693.151,598.425Z",
    transform: "translate(-683.531 -588.409)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27750",
    "data-name": "Path 27750",
    d: "M489.23,601.094a.466.466,0,0,1-.393-.716,4.887,4.887,0,0,1,.946-1.013,2.591,2.591,0,0,0,.95-1.223,2.54,2.54,0,0,0-.144-1.621.466.466,0,0,1,.851-.379,3.081,3.081,0,0,1-1.04,3.921,4.132,4.132,0,0,0-.776.815A.466.466,0,0,1,489.23,601.094Z",
    transform: "translate(-482.693 -588.409)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27751",
    "data-name": "Path 27751",
    d: "M331.88,537.787a.466.466,0,0,1-.416-.256,2.162,2.162,0,0,1-.214-.695,1.523,1.523,0,0,1,.185-.923,3.262,3.262,0,0,1,.578-.718,1.519,1.519,0,0,0,.5-.721,1.426,1.426,0,0,0-.146-.9.466.466,0,1,1,.822-.438,2.343,2.343,0,0,1,.241,1.5,2.29,2.29,0,0,1-.749,1.212,2.492,2.492,0,0,0-.423.509.6.6,0,0,0-.079.367,1.243,1.243,0,0,0,.121.387.466.466,0,0,1-.416.676Z",
    transform: "translate(-327.487 -523.544)",
    fill: "#006"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.297c18c0535e64040a550761db88e278.svg";
export { ForwardRef as ReactComponent };